
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Aboutuspage from './components/pages/Aboutuspage';
import Termconditions from './components/pages/TermConditions';
import Showroompage from './components/pages/Showroompage';
import Privacy from './components/pages/Privacy';
function App() {
  return (
    <Router>
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/contact-us" element={<Contactus/>}/>
      <Route axact path="/about-us" element={<Aboutuspage/>}/>
      <Route axact path="/terms" element={<Termconditions/>}/>
      <Route axact path="/privacy-policy" element={<Privacy/>}/>
      <Route axact path="/showroom-photo" element={<Showroompage/>}/>
      </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
